module.exports = __webpack_public_path__ + "static/media/17.fa6fdd8f.jpg";